<template>
    <transition name="slide" @after-enter="afterEnter">
        <div v-show="toastConfig.show" class="tip">
            <div v-if="toastConfig.type === 'error'" class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none">
                    <rect x="1" y="1.70312" width="46" height="45.5856" rx="22.7928" fill="#E60101" />
                    <path
                        d="M36.2362 12.5057C37.0265 13.2888 37.0265 14.5589 36.2362 15.342L27.0391 24.4562L36.2362 33.5705C37.0262 34.3535 37.0268 35.6229 36.2369 36.406C35.4468 37.1891 34.1651 37.189 33.3749 36.406L24.2541 27.3674L15.1333 36.406C14.3431 37.1891 13.0615 37.1891 12.2713 36.406C11.4812 35.6229 11.4811 34.3529 12.2713 33.5698L21.4691 24.4548L12.2713 15.3399C11.4813 14.5568 11.4819 13.2874 12.272 12.5044C13.0621 11.7213 14.3431 11.7207 15.1333 12.5037L24.2555 21.5437L33.3749 12.5064C34.1651 11.7234 35.446 11.7229 36.2362 12.5057Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div class="text" v-html="toastConfig.tip"></div>
            <div v-if="toastConfig.show" class="loader"></div>
        </div>
    </transition>
</template>
<script setup lang="ts">
import { useBaseStore } from '@/stores'
import { storeToRefs } from 'pinia'

const store = useBaseStore()

const { toastConfig } = storeToRefs(store)

// 进入动画结束后触发
const afterEnter = () => {
    setTimeout(() => {
        toastConfig.value.show = false
    }, 3000) // 停留2秒
}
</script>
<style lang="scss" scoped>
.tip {
    @apply flex items-center gap-[10px];
    position: fixed;
    top: 90px;
    left: 50%;
    width: 696px;
    min-height: 90px;
    padding: 24px 24px;
    border-radius: 30px;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(40px);

    transform: translateX(-50%);
    // border: 1px solid rgba(42, 238, 136, 0.3);

    z-index: 9000;

    .icon {
        @apply flex justify-center items-center;
        width: 48px;
        height: 47px;

        svg {
            width: 100%;
            height: 100%;
        }
    }

    .text {
        flex: 1;
        color: #fff;

        text-align: left;
        font-size: 30px;
        font-weight: 400;
        word-break: break-word;
    }
}

/* 进入前/离开后状态 */
.slide-enter-from,
.slide-leave-to {
    transform: translateX(calc(100vw + 50%)); /* 从右侧不可见区域开始 */
}

/* 进入/离开活动状态 */
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease-in-out;
}

/* 进入后/离开前状态 */
.slide-enter-to,
.slide-leave-from {
    transform: translateX(-50%); /* 停留在中间 */
}

.loader {
    width: 60px;
    aspect-ratio: 1;
    border: 10px solid #020202;
    border-radius: 50%;
    position: relative;
    transform: rotate(45deg);
}
.loader::before {
    content: '';
    position: absolute;
    inset: -10px;
    border-radius: 50%;
    border: 11px solid #fa3374;
    animation: l18 3.1s 0.25s infinite linear;
}
@keyframes l18 {
    0% {
        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
}
</style>
